// extracted by mini-css-extract-plugin
module.exports = {"sideBySideLayout":"SideBySideLayout-hashed__sideBySideLayout__1myXT","left":"SideBySideLayout-hashed__left__3bp0g","right":"SideBySideLayout-hashed__right__1CEEn"};